import { render, staticRenderFns } from "./DisperseSolutions.vue?vue&type=template&id=4148ea80&"
import script from "./DisperseSolutions.vue?vue&type=script&lang=js&"
export * from "./DisperseSolutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports